<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="activeAccounts"
      item-key="user.uid"
      multi-sort
      :search="search"
      sort-by="user.lastName"
      class="elevation-2"
      max-height="800px auto"
      @click:row="viewAccount"
    >
      <template v-slot:top>
        <v-card flat>
          <v-card-subtitle>
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <v-text-field
                  v-model="search"
                  outlined
                  append-icon="mdi-magnify"
                  label="Nach Personen suchen"
                  :disabled="!activeAccounts.length"
                  hide-details="auto"
                  clearable
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-divider></v-divider>
        </v-card>
      </template>
      <template v-slot:[`item.profil`]="{ item }">
        <v-badge
          bordered
          overlap
          dot
          bottom
          :color="avatarColorFromStatus(item.access.status)"
        >
          <v-avatar
            size="34"
            rounded
            :color="
              $vuetify.theme.dark
                ? 'rgba(255, 255, 255, 0.12)'
                : 'grey lighten-2'
            "
            class="font-weight-medium"
            >{{ initials(item.user.displayName) }}</v-avatar
          >
        </v-badge>
      </template>
      <template v-slot:[`item.access.status`]="{ item }">
        <v-chip
          :color="
            item.access.status === 'activated'
              ? 'green lighten-4'
              : 'red lighten-4'
          "
          small
          label
          :class="
            item.access.status === 'activated'
              ? 'font-weight-medium green--text text--darken-4'
              : 'font-weight-medium red--text text--darken-4'
          "
          >{{ textFromUserStatus(item.access.status) }}</v-chip
        >
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="red darken-1" @click="viewAccount(item)">
          mdi-chevron-right
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "active-accounts-table",
  props: {
    activeAccounts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", value: "profil", sortable: false },
        { text: "Vorname", value: "user.firstName" },
        { text: "Nachname", value: "user.lastName", divider: true },
        { text: "Abteilung", value: "user.division.title", divider: true },
        { text: "Benutzergruppe", value: "group.title", divider: true },
        { text: "Status", value: "access.status", divider: true },
        { text: "Organisationsbeitritt", value: "user.memberSince" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  created() {},
  computed: {},
  methods: {
    initials(fullName) {
      const namesArray = fullName.trim().split(" ");
      if (namesArray.length === 1) return `${namesArray[0].charAt(0)}`;
      else
        return `${namesArray[0].charAt(0)}${namesArray[
          namesArray.length - 1
        ].charAt(0)}`;
    },
    avatarColorFromStatus(item) {
      switch (item) {
        case "activated":
          return "green";
        case "deactivated":
          return "warning";
        case "error":
          return "error";
        default:
          return "";
      }
    },
    textFromUserStatus(item) {
      switch (item) {
        case "activated":
          return "Zugang aktiv";
        case "deactivated":
          return "Zugang deaktiviert";
        default:
          return "";
      }
    },
    viewAccount(item) {
      this.$router.push({
        name: "admin-users-tab-accounts-account-details",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.user.uid,
        },
      });
    },
  },
};
</script>
